import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../LangContext';
import { SocialIcons } from './socials';
import API from '../api';

export default function Footer() {
  const { t } = useLang();
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await API.post('/newsletter/subscribe', { email: email.trim() });
    } catch {}
    setSubscribed(true);
    setLoading(false);
  };

  return (
    <footer style={{ 
      background: 'var(--secondary)', 
      padding: '48px 24px 32px',
      marginTop: 48,
      color: '#fff'
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>

        {/* Newsletter Subscribe Bar */}
        <div style={{
          background: 'rgba(255,255,255,0.06)',
          borderRadius: 20, padding: '24px 40px', marginBottom: 32,
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 24,
          border: '1px solid rgba(255,255,255,0.08)', flexWrap: 'wrap',
        }}>
          <div style={{ flex: '1 1 300px' }}>
            <h3 style={{ fontSize: 20, fontWeight: 800, marginBottom: 6, color: 'var(--primary)' }}>Stay Updated</h3>
            <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 14, lineHeight: 1.5 }}>
              Get the latest news, deals, and business insights delivered to your inbox.
            </p>
          </div>
          <div style={{ flex: '1 1 400px' }}>
            {!subscribed ? (
              <form onSubmit={handleSubscribe} style={{ display: 'flex', gap: 10, maxWidth: 480 }}>
                <input type="email" required placeholder={t.mpNewsletterPlaceholder || 'Enter your email'}
                  value={email} onChange={e => setEmail(e.target.value)}
                  style={{ flex: 1, padding: '14px 20px', borderRadius: 12, border: 'none', fontSize: 14, outline: 'none' }} />
                <button type="submit" disabled={loading} style={{
                  padding: '14px 28px', background: 'var(--primary)', color: '#fff',
                  borderRadius: 12, fontWeight: 700, fontSize: 14, border: 'none',
                  cursor: loading ? 'not-allowed' : 'pointer', whiteSpace: 'nowrap',
                  opacity: loading ? 0.7 : 1,
                }}>
                  {loading ? '...' : (t.mpNewsletterBtn || 'Subscribe')}
                </button>
              </form>
            ) : (
              <div style={{ fontSize: 16, color: '#4ADE80', fontWeight: 600, padding: '14px 0' }}>
                {t.mpNewsletterSuccess || 'Thank you for subscribing!'}
              </div>
            )}
          </div>
        </div>

        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: 32,
          marginBottom: 32
        }}>
          {/* Logo & Description */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
              <img src="/images/logo.jpg" alt="All Things" style={{ width: 40, height: 40, borderRadius: 8, objectFit: 'cover' }} />
              <span style={{ fontSize: 24, fontWeight: 900, color: '#fff' }}>All<span style={{ color: 'var(--primary)' }}>Things</span></span>
            </div>

          </div>

          {/* Navigation */}
          <div>
            <h4 style={{ fontSize: 15, fontWeight: 700, color: '#fff', marginBottom: 16, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Quick Links</h4>
            <div style={{ display: 'flex', gap: 24 }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 14, flex: 1 }}>
                <Link to="/website" style={{ color: 'rgba(255,255,255,0.6)', fontSize: 15, textDecoration: 'none', transition: 'color 0.2s' }}
                  onMouseEnter={e => e.target.style.color = '#fff'}
                  onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.6)'}>{t.home}</Link>
                <Link to="/clients" style={{ color: 'rgba(255,255,255,0.6)', fontSize: 15, textDecoration: 'none', transition: 'color 0.2s' }}
                  onMouseEnter={e => e.target.style.color = '#fff'}
                  onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.6)'}>{t.clients}</Link>
                <Link to="/blog" style={{ color: 'rgba(255,255,255,0.6)', fontSize: 15, textDecoration: 'none', transition: 'color 0.2s' }}
                  onMouseEnter={e => e.target.style.color = '#fff'}
                  onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.6)'}>Blogs/News</Link>
              </div>
              <div style={{ width: 1, backgroundColor: 'rgba(255,255,255,0.15)', minHeight: 120 }} />
              <div style={{ display: 'flex', flexDirection: 'column', gap: 14, flex: 1 }}>
                <Link to="/about" style={{ color: 'rgba(255,255,255,0.6)', fontSize: 15, textDecoration: 'none', transition: 'color 0.2s' }}
                  onMouseEnter={e => e.target.style.color = '#fff'}
                  onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.6)'}>{t.about}</Link>
                <Link to="/contact" style={{ color: 'rgba(255,255,255,0.6)', fontSize: 15, textDecoration: 'none', transition: 'color 0.2s' }}
                  onMouseEnter={e => e.target.style.color = '#fff'}
                  onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.6)'}>{t.contact}</Link>
                <Link to="/bazaar" style={{ color: 'rgba(255,255,255,0.6)', fontSize: 15, textDecoration: 'none', transition: 'color 0.2s' }}
                  onMouseEnter={e => e.target.style.color = '#fff'}
                  onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.6)'}>Bazaar</Link>
              </div>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ fontSize: 15, fontWeight: 700, color: '#fff', marginBottom: 16, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Contact Us</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <a href="mailto:allthingsethiopia2026@gmail.com" style={{ color: 'rgba(255,255,255,0.6)', fontSize: 15, textDecoration: 'none', transition: 'color 0.2s' }}
                onMouseEnter={e => e.target.style.color = '#fff'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.6)'}>
                allthingsethiopia2026@gmail.com
              </a>
              <a href="tel:+251905841982" style={{ color: 'rgba(255,255,255,0.6)', fontSize: 15, textDecoration: 'none', transition: 'color 0.2s' }}
                onMouseEnter={e => e.target.style.color = '#fff'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.6)'}>
                +251 905 841 982
              </a>
              <a href="tel:+251967033544" style={{ color: 'rgba(255,255,255,0.6)', fontSize: 15, textDecoration: 'none', transition: 'color 0.2s' }}
                onMouseEnter={e => e.target.style.color = '#fff'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.6)'}>
                +251 967 033 544
              </a>
              <a href="tel:+251911031884" style={{ color: 'rgba(255,255,255,0.6)', fontSize: 15, textDecoration: 'none', transition: 'color 0.2s' }}
                onMouseEnter={e => e.target.style.color = '#fff'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.6)'}>
                +251 911 031 884
              </a>
              <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: 15, lineHeight: 1.6 }}>
                Addis Ababa, Ethiopia
              </div>
            </div>
          </div>

          {/* Social */}
          <div>
            <h4 style={{ fontSize: 15, fontWeight: 700, color: '#fff', marginBottom: 16, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Follow Us</h4>
            <SocialIcons size={40} iconSize={18} light />
          </div>
        </div>

        <div style={{ 
          borderTop: '1px solid rgba(255,255,255,0.1)', 
          paddingTop: 24, 
          textAlign: 'center',
        }}>
          <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 14 }}>
            {t.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
}
